module.exports = __webpack_public_path__ + "static/media/default-user.fac07a8d.svg";